import { navegar } from "./ruta";

// Abrir Catálogo con algo ya puesto, desde otra pantalla (tramo 07 de huayruro-orden-y-mapa):
//   · «Crear producto» del Mostrador (RU-1): el alta con el código o el nombre que no se encontró
//   · «Corregir precio» del Mostrador (O-11): ese producto abierto en «Editar precios y presentaciones»
//
// El pedido viaja en memoria y no en el hash: `useRuta` compara el hash exacto (un `?codigo=` lo haría
// caer al inicio) y los 27 hashes no cambian (regla 1 del brief). Catálogo lo LEE en el estado inicial y
// lo OLVIDA en un efecto después de montar: con StrictMode, React llama dos veces al inicializador del
// estado, y un «leer y borrar» ahí dejaría la segunda llamada sin pedido.

// `sucursalId`: si quien pide es el dueño atendiendo en una botica, los precios se abren en ESA botica
// (sin esto, Catálogo le pediría elegirla otra vez y podría corregir el precio en la equivocada).
export type PedidoCatalogo = (
  | { tipo: "alta"; gtin: string | null; nombre: string | null }
  | { tipo: "editar"; productoId: string; nombre: string }
) & { sucursalId?: string | null };

let pendiente: PedidoCatalogo | null = null;

export function abrirCatalogoCon(pedido: PedidoCatalogo): void {
  pendiente = pedido;
  navegar("catalogo");
}

export function verPedidoCatalogo(): PedidoCatalogo | null {
  return pendiente;
}

export function olvidarPedidoCatalogo(): void {
  pendiente = null;
}

// Un texto de búsqueda que parece código de barras (solo dígitos, de 8 a 14) va al campo del código;
// cualquier otro, al nombre.
export function separarCodigoONombre(texto: string): { gtin: string | null; nombre: string | null } {
  const t = texto.trim();
  if (!t) return { gtin: null, nombre: null };
  return /^\d{8,14}$/.test(t) ? { gtin: t, nombre: null } : { gtin: null, nombre: t };
}
